import { render, staticRenderFns } from "./AdvanceSettings.vue?vue&type=template&id=080e44f8"
import script from "./AdvanceSettings.vue?vue&type=script&lang=js"
export * from "./AdvanceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports